/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取剧院会员所有等级及权益
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.TheaterMemberRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/theater/member`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
